import React, { useState } from 'react';
import { JsonImport } from './JsonImport.tsx';
import { CsvImport } from './CsvImport.tsx';
import './ImportDialog.css';

interface ImportDialogProps {
  onClose: () => void;
}

export const ImportDialog: React.FC<ImportDialogProps> = ({ onClose }) => {
  const [importType, setImportType] = useState<'csv' | 'json'>('csv');

  return (
    <div className="import-dialog">
      <div className="import-type-selector">
        <button 
          onClick={() => setImportType('csv')}
          className={importType === 'csv' ? 'active' : ''}
        >
          CSV Import
        </button>
        <button 
          onClick={() => setImportType('json')}
          className={importType === 'json' ? 'active' : ''}
        >
          JSON Import
        </button>
      </div>

      {importType === 'csv' ? (
        <CsvImport onClose={onClose} />
      ) : (
        <JsonImport onClose={onClose} />
      )}
    </div>
  );
}; 